/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthRefreshRequest, AuthRefreshResponse } from '../types/AuthRefresh'

/**
 * POST /auth/refresh
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::refresh
 */
export async function authRefresh(
	data: AuthRefreshRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthRefreshResponse>> {
	return axiosInstance.post('/auth/refresh', data, config)
}
